import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Box, Link } from '@mui/material';

const navItems = [
  { label: 'News', href: '#news' },
  { label: 'Publications', href: '#publications' },
  { label: 'Research', href: '#research' },
  { label: 'Industry', href: '#industry' },
  { label: 'Teaching', href: '#teaching' },
];

const NavBar = () => {
  // Highlight the link for whichever section is currently in view.
  const [active, setActive] = useState(null);
  useEffect(() => {
    const sections = navItems.map((item) => document.querySelector(item.href)).filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(`#${entry.target.id}`);
        });
      },
      { rootMargin: '-80px 0px -70% 0px' }
    );
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(8px)',
        borderBottom: 1,
        borderColor: 'divider',
        color: 'text.primary',
      }}
    >
      <Toolbar sx={{ maxWidth: 880, width: '100%', mx: 'auto', px: { xs: 2, md: 3 }, gap: 2 }}>
        <Link
          href="#top"
          sx={{ display: { xs: 'none', sm: 'block' }, fontWeight: 700, color: 'text.primary', whiteSpace: 'nowrap' }}
        >
          Anastasiya Masalava
        </Link>
        <Box
          component="nav"
          sx={{ ml: 'auto', minWidth: 0, display: 'flex', gap: { xs: 1.5, md: 3 }, overflowX: 'auto', fontSize: '0.9rem' }}
        >
          {navItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              sx={{
                color: active === item.href ? 'primary.main' : 'text.secondary',
                fontWeight: active === item.href ? 600 : 400,
                whiteSpace: 'nowrap',
                '&:hover': { color: 'primary.main' },
              }}
            >
              {item.label}
            </Link>
          ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
